module.exports = __webpack_public_path__ + "img/p-39.bda25922.jpg";